import { Navigate, useParams } from "react-router-dom";

/** Redirect old /students/:id bookmarks to qari progress route */
export default function LegacyQariStudentRedirect() {
  const { studentId } = useParams();
  return <Navigate to={`/dashboard-qari/students/${studentId}`} replace />;
}
